export default {
  searchText: '',
  orderName: 'created_at',
  sortAsc: false
}
